const LOCAL_API_BASE_URL = "http://localhost:8000";
const US_PROD_API_BASE_URL =
  "https://hgc567ge6f.execute-api.us-east-1.amazonaws.com/v0";

declare const KELLS_SG_API_URL: string | undefined;
declare const KELLS_API_MODE: string | undefined;
declare const KELLS_DIRECT_S3_UPLOAD: string | undefined;

/**
 * Dual-region API base URL.
 * Priority:
 * 1. KELLS_SG_API_URL (build-time — SG Netlify CI only)
 * 2. KELLS_API_MODE=dev → localhost
 * 3. Default → US production API Gateway
 */
function resolveApiBaseUrl(): string {
  const explicitUrl =
    typeof KELLS_SG_API_URL === "string" ? KELLS_SG_API_URL.trim() : "";
  if (explicitUrl) {
    return explicitUrl.replace(/\/$/, "");
  }

  const explicitMode =
    typeof KELLS_API_MODE === "string"
      ? KELLS_API_MODE.trim().toLowerCase()
      : "";
  if (explicitMode === "dev") {
    return LOCAL_API_BASE_URL;
  }
  // "prod" and unset both resolve to US production (unchanged US behavior).
  return US_PROD_API_BASE_URL;
}

function resolveDirectS3UploadEnabled(): boolean {
  const rawValue =
    typeof KELLS_DIRECT_S3_UPLOAD === "string"
      ? KELLS_DIRECT_S3_UPLOAD.trim().toLowerCase()
      : "";
  if (!rawValue) {
    return true;
  }
  return rawValue === "1" || rawValue === "true" || rawValue === "yes";
}

export const apiEnvironment = {
  applicationBaseUrl: "http://localhost:4200",
  apiBaseUrl: resolveApiBaseUrl(),
  apiVersion: "api/v1",
  directS3UploadEnabled: resolveDirectS3UploadEnabled(),
  predictBaseUrl: "https://g6pozkyqya.execute-api.us-east-1.amazonaws.com/v1",
  optioBaseUrl: "https://optiopublishing.com",
  optioUser: "dev@getkells.com",
  optioCred: "&rPdE!445^8YlE%",
};
